import { formatMetricInQueue, formatTagsInQueue } from "../helpers/host-view";
import hash from "object-hash";

export const INITIAL_STATE = {
  queue: [],
  openCharts: [],
};

export const RESET_QUEUE = "infrastructure/hostView/RESET_QUEUE";
export const ADD_TO_QUEUE = "infrastructure/hostView/ADD_TO_QUEUE";
export const REMOVE_FROM_QUEUE = "infrastructure/hostView/REMOVE_FROM_QUEUE";
export const ADD_OPEN_CHART = "infrastructure/hostView/OPEN_CHART";
export const REMOVE_OPEN_CHART = "infrastructure/hostView/CLOSE_CHART";

export const resetQueue = () => ({
  type: RESET_QUEUE,
});

export const addToQueue = (metric, name, tags, summaryFunction) => ({
  type: ADD_TO_QUEUE,
  metric: formatMetricInQueue(metric, tags),
  name,
  tags: formatTagsInQueue(metric, tags),
  summaryFunction,
});

export const removeFromQueue = (metric, tags) => ({
  type: REMOVE_FROM_QUEUE,
  metric,
  tags,
});

export const addOpenChart = chart => ({
  type: ADD_OPEN_CHART,
  chart,
});

export const removeOpenChart = name => ({
  type: REMOVE_OPEN_CHART,
  name,
});

const hostViewReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RESET_QUEUE:
      return {
        ...state,
        queue: [],
      };
    case ADD_TO_QUEUE:
      if (
        state.queue.find(
          item =>
            item.metric === action.metric &&
            hash(item.tags) === hash(action.tags)
        )
      ) {
        return state;
      }

      return {
        ...state,
        queue: [
          ...state.queue,
          {
            metric: action.metric,
            name: action.name,
            tags: action.tags,
            summaryFunction: action.summaryFunction,
          },
        ],
      };
    case REMOVE_FROM_QUEUE:
      return {
        ...state,
        queue: state.queue.filter(item => {
          return !(
            item.metric === action.metric &&
            hash(item.tags) === hash(action.tags)
          );
        }),
      };
    case ADD_OPEN_CHART:
      return {
        ...state,
        openCharts: [...state.openCharts, action.chart],
      };
    case REMOVE_OPEN_CHART:
      return {
        ...state,
        openCharts: state.openCharts.filter(
          chart => chart.name !== action.name
        ),
      };
    default:
      return state;
  }
};

export default hostViewReducer;
